import { useTranslate } from '@tolgee/react';
import PlatformShopAuthWayType, { PlatformShopAuthWayProps } from './PlatformShopAuthWay';
import { Form } from 'antd';
import CheckboxGroup from './CheckboxGroup';
import { useState } from 'react';
import { GenerateTikTokAuthUrlParams } from 'services/api/tiktok';

interface TikTokAuthStoreProps
  extends Omit<PlatformShopAuthWayProps, 'onNext' | 'departments' | 'setDepartments'> {
  onFinish: (departments: number[], storeType?: GenerateTikTokAuthUrlParams['storeType']) => void;
}

export const TikTokAuthStore = (props: TikTokAuthStoreProps) => {
  const { platform, onFinish, ...otherProps } = props;
  const { t } = useTranslate();
  const [departments, setDepartments] = useState<number[]>([]);

  const [form] = Form.useForm<{ storeType: GenerateTikTokAuthUrlParams['storeType'] }>();

  return (
    <>
      {platform === 'tiktok_us' && (
        <Form
          layout="vertical"
          className="w-2/3"
          form={form}
          onFinish={(values) => {
            onFinish(departments, values.storeType);
          }}
        >
          <Form.Item
            label={t('authShop.请选择您要添加的店铺类型')}
            name="storeType"
            required
            rules={[{ required: true, message: t('authShop.请选择您要添加的店铺类型') }]}
          >
            <CheckboxGroup
              options={[
                {
                  value: 'LOCAL',
                  render: t('ViewShops.LOCAL'),
                },
                {
                  value: 'CROSS',
                  render: t('ViewDashboard.跨境店铺'),
                },
              ]}
            />
          </Form.Item>
        </Form>
      )}
      <PlatformShopAuthWayType
        platform={platform}
        {...otherProps}
        departments={departments}
        setDepartments={setDepartments}
        onNext={() => {
          if (platform === 'tiktok_us') {
            setDepartments(departments ?? []);
            form.submit();
          } else {
            onFinish(departments);
          }
        }}
      />
    </>
  );
};
